import { PositionType } from "../../../entities/position";
import PositionRepository from "../../ports/positionRepository";

export type fetchPositionsUsecase = (
  limit?: number,
  where?: [string, "<" | "<=" | "==" | ">=" | ">", string | number | boolean][]
) => Promise<PositionType[]>;

export const buildFetchPositions = (dependencies: {
  positionRepo: PositionRepository;
}): fetchPositionsUsecase => {
  const { positionRepo } = dependencies;

  const fetchPositions: fetchPositionsUsecase = async (
    limit?: number,
    where?: [
      string,
      "<" | "<=" | "==" | ">=" | ">",
      string | number | boolean
    ][]
  ) =>
    positionRepo.fetchPositions(limit, where);

  return fetchPositions;
};
